import { render, staticRenderFns } from "./selfOperatedProductsDetails.vue?vue&type=template&id=5cae72a5&scoped=true"
import script from "./selfOperatedProductsDetails.vue?vue&type=script&lang=js"
export * from "./selfOperatedProductsDetails.vue?vue&type=script&lang=js"
import style0 from "./selfOperatedProductsDetails.vue?vue&type=style&index=0&id=5cae72a5&prod&lang=less"
import style1 from "./selfOperatedProductsDetails.vue?vue&type=style&index=1&id=5cae72a5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cae72a5",
  null
  
)

export default component.exports